export const TODO_DATE_PERIOD_FILTERS = {
  TODAY: { value: "today", label: "Today" },
  TOMORROW: { value: "tomorrow", label: "Tomorrow" },
  WEEK: { value: "week", label: "This week" },
  UPCOMING: { value: "upcoming", label: "Upcoming" },
  DONE: { value: "done", label: "Done" },
} as const;

export const TODO_PRIORITY = {
  HIGH: { value: 1, label: "High" },
  MEDIUM: { value: 2, label: "Medium" },
  LOW: { value: 3, label: "Low" },
  NONE: { value: 4, label: "None" },
} as const;
